import { useCallback, useEffect, useState } from 'react';
import EventBus from '../../utils/EventBus';
import './index.scss';
import userUtils from '../../manager/userUtils';
import rm from '../../utils/rm';
import settings from '../../utils/settings';
import { Image } from 'antd';
import { processNUmber } from '../Coin';
import SpaceHolder from '../SpaceHolder';
import util from '../../utils/util';

const MyMallCard = () => {

    const [userInfo, setUserInfo] = useState<any>(settings.getItem("userInfo", {}));
    const [hasUserInfo, setHasUserInfo] = useState<boolean>(settings.getItem("hasUserInfo", false));
    const [getCoinLink, setGetCoinLink] = useState<{ title: string, link: string }>(settings.getItem("getCoinLink", undefined))
    // const [coinHistoryLink, setCoinHistoryLink] = useState<string>(settings.getItem("coinHistoryLink", undefined))
    const switchUILoginState = useCallback(() => {
        userUtils.getUserInfoAsync((userInfo) => {
            if (userInfo != null && userInfo.userid > 0) {
                console.log('当前用户信息：', userInfo);
                switch (rm.getEnv().app) {
                    case "ithome":
                        setGetCoinLink({
                            title: "去赚金币",
                            link: "https://img.ithome.com/app/newmy/apppage/user/signin.html?hidemenu=1"
                        })
                        break;
                    case "zuihuimai":
                        setGetCoinLink({
                            title: "兑换金币",
                            link: "https://api.zuihuimai.com/m/user/usercoin?userhash=%7Buserhash%7D"
                        })
                        break
                }
                setUserInfo(userInfo);
                setHasUserInfo(true)
            } else {
                setHasUserInfo(false);
                setUserInfo({})
            }
        })
    }, [])

    useEffect(() => {
        settings.setItem("userInfo", userInfo);
        settings.setItem("hasUserInfo", hasUserInfo);
        settings.setItem("getCoinLink", getCoinLink);
    }, [hasUserInfo, userInfo, getCoinLink])

    useEffect(() => {
        const userLoginStateChanged = () => {
            switchUILoginState()
        }
        EventBus.register(EventBus.names.USER_LOGIN_STATE_CHANGE, userLoginStateChanged);
        switchUILoginState();
        return () => {
            EventBus.unregister(EventBus.names.USER_LOGIN_STATE_CHANGE, userLoginStateChanged);
        }
    }, [])

    return <div className='my-mall-card'>
        {hasUserInfo ? <div className='line'>
            <span className='total-coin-number' onClick={() => {
                const url = `https://m.ithome.com/fund/coindetail?hidemenu=1&needlogin=1&userhash=${userUtils.getUserHash()}`;
                util.navigateTo(url,);
                console.log('跳转金币明细', url, userUtils.getUserHash());
            }}>
                <img src="https://img.ithome.com/m/images/app/coin-ico.png" />
                <span>{processNUmber(userInfo.coin)}</span>
                <Image
                    preview={false}
                    className="icon-arrow"
                    src={require('../../images/right-arrow-grey.png')}
                ></Image>
            </span>
            <SpaceHolder />
            <span className='btn' onClick={() => {
                util.navigateTo(`/me?isrmmp=1&hidemenu=1`);
            }}>我的商城</span>
            <span className='btn' onClick={() => {
                util.navigateTo(getCoinLink.link);
            }}>{getCoinLink.title}</span>
        </div> : <div className='line'
            onClick={() => {
                userUtils.doTaskInLoginState(function (state) {
                    if (state.success) {

                    }
                })
            }}>
            <span>登录账户，做任务赚金币兑好礼。</span>
            <Image
                preview={false}
                className="icon-arrow"
                src={require('../../images/right-arrow-grey.png')}
            ></Image>
        </div>}
    </div>
}

export default MyMallCard;